import { TravelstoryPreviewFields } from 'modules/TravelstoryModule/TravelstoryModule.fields';

export const TravelstoriesBlockFields = `
{
    title
    travelstories ${TravelstoryPreviewFields}
}
`;
